export class Constant {
  public static readonly PREFIX_URL = "/";
  public static readonly LANGUAGE = "lang";
  public static readonly ENGLISH = "en";
  public static readonly SOUTH_KOREA = "kr";
  public static readonly VIETNAME = "vn";

  public static readonly STATUS_USER = "02";
  public static readonly LOCKED = "02-01";
  public static readonly DISABLED = "02-02";
  public static readonly ACTIVED = "02-03";

  public static readonly GENDER = "05";

  public static readonly START_PAGE = 1;
  public static readonly ROWS_OF_PAGE = 10;

  public static readonly FORMAT_YMD = "YYYY-MM-DD";
  public static readonly FORMAT_YMDHM = "YYYY-MM-DD HH:mm"
  public static readonly FORMAT_FULL = "YYYY-MM-DD HH:mm:ss"
  public static readonly FORMAT_YMD_KR = "YYYY년 MM월 DD일";
  public static readonly FORMAT_YMD_ALT = "YYYYMMDD";
  public static readonly FORMAT_YMDHMS = "YYYYMMDDHHmmss";
  public static readonly PRIME_FORMAT_DATE_EN = "dd-mm-yy";
  public static readonly PRIME_FORMAT_DATE_KR = "yy-mm-dd";
  public static readonly ACTIVE_STATUS = 'Active';
  public static readonly INACTIVE_STATUS = 'Inactive';
  public static readonly DISABLED_STATUS = 'Disabled';
  public static readonly LOCK_STATUS = 'Lock';

  public static readonly GET_METHOD = 'GET';
  public static readonly POST_METHOD = 'POST';
  public static readonly PUT_METHOD = 'PUT';
  public static readonly DELETE_METHOD = 'DELETE';

  public static readonly PUBLIC_KEY = 'PublicKey';

  public static readonly RE100_ADJ_PWR_EMSN_COEF = 0.4747;
  public static readonly RE100_ADJ_PWR_EMSN_SOLAR = 0.4403;
  public static readonly OT_HD_AVG_REWARD = 150;
  public static readonly OT_DC_COMPLEX_NM = 'DC그리드';

  public static readonly DC_GONGDOJANG = '200004';
  public static readonly DC_SCIENCE = '200005';
  public static readonly HD_KEPCO = '200006';
  public static formatDCHDId(id: string) {
    switch(id) {
      case '200001': return '공용PV';
      case '200002': return 'Fresh_ESS';
      case '200003': return 'Reuse_ESS';
      case '200004': return '궁도장';
      case '200005': return '과학관';
      case '200006': return '한국전력공사';
      default: return '-';
    }
  }
}
export const {formatDCHDId} = Constant;
